import {useContext} from 'react'
import {SubscriptionContext} from './SubscriptionContext'

export const useSubscription = () => {
  const contextInstance = useContext(SubscriptionContext)
  if (!contextInstance) throw new Error('Cannot call useSubscription() outside of <SubscriptionProvider>')
  return contextInstance
}
